import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getIndustriesForNavigation } from '@/services/strapi/navigation';

export const industries = createQueryKeys('industries', {
  navigation: { queryKey: null, queryFn: getIndustriesForNavigation },
});
